module.exports = __webpack_public_path__ + "static/media/AB_B6_1.31c22bb5.jpg";